<template>
<div class="rules-modal-popup rules_m">
        <div class="modal fade" id="wpolicy-modal-popup" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-0 p-0">
                        <button type="button" class="btn-cl" data-bs-dismiss="modal" aria-label="Close"><img
                                src="@/assets/images/close_m.svg" alt="m_close" /></button>
                    </div>
                    <div class="modal-body p-2">
                        <div class="flex flex-col gap-y-2" style="max-height: 450px; overflow-y: auto;">
                            <div class="text-base font-lato font-semibold text-text_Ternary">Terms and Conditions:</div>

                            <div class="text-text_w_policy">
                                <p>
                                    &amp;quot;Limits The maximum deposit limit on your account will vary depending on
                                    how long you have been a customer with us and whether you have successfully passed
                                    our security checks. Please contact
                                    the
                                    <a :href="'mailto:'+ $siteSettings?.data?.social_link?.email"
                                        class="px-1 font-bold text-sm text-text_Primary">{{$siteSettings?.data?.social_link?.email}}</a>for
                                    further information &amp;quot;
                                </p>
                                <p>
                                    Security Please note you may be asked to supply proof of identity and address before
                                    making a withdrawal from your account. Credit and Debit card payments undergo a 3D
                                    Secure process. To find out
                                    more, please click here.
                                </p>
                                <p>
                                    Withdrawals Withdrawals will be directed to the same source. If your query is not
                                    covered by the information contained here, please email
                                    <a :href="'mailto:'+$siteSettings?.data?.social_link?.email"
                                        class="px-1 font-bold text-sm text-text_Primary">{{$siteSettings?.data?.social_link?.email}}</a> where
                                    staff will be on hand to answer your query.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
export default {
    name: "RulesModal",
};
</script>